module.exports = __webpack_public_path__ + "static/media/29COICT3.61499052.jpg";